import { EventEmitter, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { productitems } from '../classes/productitems';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();
  machineId: number = 0;
  private _isSearchDisable = new BehaviorSubject<boolean>(false);
  $isSearchDisableObs = this._isSearchDisable.asObservable();
  private machineIdSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  machineId$: Observable<number> = this.machineIdSubject.asObservable().pipe(
    distinctUntilChanged()
  );
  private cartCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  cartCount$ = this.cartCountSubject.asObservable();
  loginType: string = "";
  genieNameEmitter = new EventEmitter<string>();
  cartItems: productitems[] = [];
  totalCartPriceSubj: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  totalCartPrice$ = this.totalCartPriceSubj.asObservable();
  totalObj = {
  };
  private prodSearchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
  prodSearchObs$ = this.prodSearchTerm.asObservable();
  private activeFooter: BehaviorSubject<string> = new BehaviorSubject<string>("");
  activeFooterObjs$ = this.activeFooter.asObservable();
  // to set color for elected buttons(mfg-header-component)
  public selectedButton: BehaviorSubject<string> = new BehaviorSubject<string>('profile');
  public selectedButton$ = this.selectedButton.asObservable();
  //  myOrdersSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  public switchChangeView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  switchChangeView$: Observable<boolean> = this.switchChangeView.asObservable();
  public MachineproductItem: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  machineproductItemCount$ = this.MachineproductItem.asObservable();
  private genieStatus = new BehaviorSubject<string>("");
  $genieStatusObs = this.genieStatus.asObservable();



  constructor() { }
  setIsSearchDisable(value: boolean) {
    return this._isSearchDisable.next(value);
  }
  getIsSearchDisable(): boolean {
    return this._isSearchDisable.value;
  }
  setMachineId(value: number) {
    // this.productService.setProductsByGenie(value);
    this.machineIdSubject.next(value);

  }
  getMachineId() {
    return this.machineIdSubject.value;
  }
  sendUpdate(message: string) { //sender
    this.messageSource.next(message)
  }
  getUpdate(): Observable<any> { //the receiver component calls this function 
    return this.messageSource.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
  }
  setCartCount(value: number) {
    this.cartCountSubject.next(value);
  }

  getCartCount(): number {
    return this.cartCountSubject.value;
  }
  setCartItems(array: productitems[]) {
    this.cartItems = array;
    this.updateCartTotalPrice();
    // if(this.cartItems?.length>0){
    //   localStorage.setItem('genieCartItems', JSON.stringify(this.cartItems));
    // }
  }
  updateCartTotalPrice() {
    let totalPrice: number = 0;
    this.cartItems.forEach(cart => {
      totalPrice += cart.totalPrice;
    });
    this.totalCartPriceSubj.next(totalPrice);
  }
  setCartItem(prod: productitems, index: number) {
    this.cartItems[index] = prod;
    this.updateCartTotalPrice();
  }
  getCartItems() {
    return this.cartItems;
  }
  delCartItemObj(currentobj: productitems) {
    const objIndex = this.cartItems.findIndex((obj) => obj.prodId == currentobj.prodId && obj.genieId == currentobj.genieId && obj.rackId == currentobj.rackId && obj.slotId == currentobj.slotId);
    // const storageItems = localStorage.getItem('genieCartItems');
    // if(storageItems){
    //   const storageItemsArray = JSON.parse(storageItems);
    //   const objIndex = this.cartItems.findIndex((obj)=> obj.prodId ==currentobj.prodId);
    //   if(objIndex !=-1){
    //    storageItemsArray.splice(objIndex,1);
    //    localStorage.setItem('genieCartItems', JSON.stringify(storageItemsArray));
    //   }
    // } 
    if (objIndex != -1) {
      this.cartItems.splice(objIndex, 1);
    }
    this.updateCartTotalPrice();
    // this.setCartItems(this.cartItems);
  }
  getCartItemCount() {
    const result = this.cartItems.reduce(
      (accumulator, currentItem) => {
        accumulator.totalCount += currentItem.itemCount;
        accumulator.totalPrice += currentItem.totalPrice;
        return accumulator;
      },
      { totalCount: 0, totalPrice: 0 }
    );
    return result;
  }
  setLoginType(type: string) {
    this.loginType = type;
  }
  getLoginType() {
    return this.loginType;
  }
  UpdateGenieName(value: string) {
    this.genieNameEmitter.emit(value);
  }
  getProdTerm() {
    return this.prodSearchTerm.value;
  }
  setProdTerm(value: string) {
    const sanitizedValue = value !== '' ? value : null;
    this.prodSearchTerm.next(sanitizedValue);
    // this.prodSearchTerm.next(value);
  }
  getFooterActie() {
    return this.activeFooter.value;
  }
  setFooterActie(value: string) {
    this.activeFooter.next(value);
  }
  setSelectedButton(button: string) {
    this.selectedButton.next(button);
  }
  setSelectedView(value: boolean) {
    this.switchChangeView.next(value);
  }
  setMachineproductItemCount(index: number) {
    this.MachineproductItem.next(index);
  }
  setGenieStatus(value: string) {
    this.genieStatus.next(value);
  }
  getGenieStatus() {
    return this.genieStatus.value;
  }
}